import React from 'react';
import { faStopwatch } from '@fortawesome/free-solid-svg-icons';

import Icon from './Icon';

const StopwatchIcon = ({ toolTipText }) => (
  <Icon tooltip={toolTipText} iconObj={faStopwatch} />
);

export default StopwatchIcon;